import List from '@/shared/dtos/List'
import PaginationInputDto from '@/shared/dtos/pagination'
import Company from '../models/Company'
import CreateCompaniesInput from './interfaces/CreateCompaniesInput'
import { HttpService } from '@/shared/services'

const http = new HttpService()

export const getCompanies = async (search?: string, clientId?: string) => {
  const http = new HttpService()
  const response = await http.get<List<Company[]>>(
    `/company?clientId=${clientId || ''}&search=${search || ''}`
  )

  return response.data
}

export const createCompanies = async (dto: CreateCompaniesInput) => {
  const response = await http.post<CreateCompaniesInput, string>(`/company`, {
    clientId: dto.clientId,
    companies: dto.companies,
  })

  return response.data
}

export const deleteCompanyById = async (id: string) => {
  const response = await http.delete(`/company/${id}`)

  return response.data
}

export const enableCompanyById = async (id: string) => {
  const response = await http.patch(`/company/enable/${id}`)

  return response.data
}

export const uploadCompanyLogo = async (companyId: string, file: File) => {
  const formData = new FormData()
  formData.append('file', file)

  const response = await http.post<any, string>(
    `/company/${companyId}/logo`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )

  return response.data
}
